/**
 * @module router/modules/dashboard
 * @description 대시보드 라우트 모듈 — 루트 경로(/)를 /dashboard로 리다이렉트하고
 * 관리자 대시보드 뷰를 제공합니다.
 */
import DashBoard from '../../views/dashboard/AdminDashBoardView.vue'

const routes = [
  {
    // 대시보드
    path: '/',
    redirect: '/dashboard',
    meta: { platform: 'web', menuYn: true, authorization: true }
  },
  {
    // 대시보드
    path: '/dashboard',
    name: '대시보드',
    component: DashBoard,
    meta: { platform: 'web', menuYn: true, authorization: true }
  }
]

export default routes
